import { FORM_BUILDER_SLUG, VIDEO_SLUG, LOGO_LIST_SLUG } from "@/lib/elements/constants";

export const ELEMENTS_TO_IGNORE = [
    VIDEO_SLUG,
    FORM_BUILDER_SLUG,
    LOGO_LIST_SLUG
];